import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Resize image to max 1600px wide, JPEG quality 0.85, return Blob
export function compressImage(file, maxWidth = 1600, quality = 0.85) {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith("image/")) {
      reject(new Error("Not an image"));
      return;
    }
    const img = new Image();
    const reader = new FileReader();
    reader.onload = (e) => {
      img.onload = () => {
        const ratio = img.width > maxWidth ? maxWidth / img.width : 1;
        const w = Math.round(img.width * ratio);
        const h = Math.round(img.height * ratio);
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        canvas.toBlob(
          (blob) => {
            if (!blob) reject(new Error("Compression failed"));
            else resolve(blob);
          },
          file.type === "image/png" ? "image/png" : "image/jpeg",
          quality
        );
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export async function uploadImage(file, password) {
  const compressed = await compressImage(file).catch(() => file);
  const formData = new FormData();
  const blob = compressed instanceof Blob ? compressed : file;
  const filename = file.name || "image.jpg";
  formData.append("file", blob, filename);
  const res = await axios.post(`${API}/admin/upload-image`, formData, {
    headers: {
      "X-Admin-Password": password,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data; // { ok, id, url }
}

export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}
